import { render, staticRenderFns } from "./AccountCostIndex.vue?vue&type=template&id=71848b1d"
import script from "./AccountCostIndex.vue?vue&type=script&lang=js"
export * from "./AccountCostIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports